import { Routes, Route } from "react-router-dom"; // Import Routes and Route for nested routing

import { ThemeProvider } from "./contexts/theme-context";
import Layout from "./routes/layout";
import DashboardPage from "./routes/dashboard/page";
import ManageCategory from "./routes/category/ManageCategory";
import ManageUsers from "./routes/users/ManageUsers";
import ManageOrders from "./routes/orders/ManageOrders";
import AddCategory from "./routes/category/AddCategory";
import ManageProduct from "./routes/product/ManageProduct";
import AddProduct from "./routes/product/AddProduct";
import EditProduct from "./routes/product/EditProduct";
import ViewProduct from "./routes/product/ViewProduct";
import ViewUser from "./routes/users/ViewUser";

import Login from "./userAuthentication/Login";
// import Testing from "./routes/product/Testing";
import OrderdItems from "./routes/orders/OrderdItems";
import ProductDetails from "./routes/orders/ProductDetails";
import PaymentDetails from "./routes/orders/PaymentDetails";
// Import the new ProtectedRoute component
import ProtectedRoute from "./ProtectedRoute"; // Adjust path as needed

function Admin() {
    return (
        <ThemeProvider storageKey="theme">
            <Routes>
                {/* Login route is accessible without being logged in */}
                <Route path="/login" element={<Login />} />

                {/* All routes nested within ProtectedRoute will require authentication */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/" element={<Layout />}>
                        {/* Define your protected admin routes here */}
                        <Route index element={<DashboardPage />} /> {/* Use index for the default child route */}
                        <Route path="/categories" element={<ManageCategory />} />
                        <Route path="/users" element={<ManageUsers />} />
                        <Route path="/viewuser/:id" element={<ViewUser />} />
                        <Route path="/orderditems/:id" element={<OrderdItems />} />
                        <Route path="/orderdproduct/:id" element={<ProductDetails />} />
                        <Route path="/paymentdetails/:id" element={<PaymentDetails/>} />
                        <Route path="/orders" element={<ManageOrders />} />
                        <Route path="/addcategory" element={<AddCategory />} />
                        <Route path="/products" element={<ManageProduct />} />
                        <Route path="/addproduct" element={<AddProduct />} />
                        {/* <Route path="/testing" element={<Testing />} /> */}
                        <Route path="/viewproduct/:id" element={<ViewProduct />} />
                        <Route path="/editproduct/:id" element={<EditProduct />} />
                        <Route path="/reports" element={<h1 className="title">Reports</h1>} />
                        <Route path="/customers" element={<h1 className="title">Customers</h1>} />
                        <Route path="/new-customer" element={<h1 className="title">New Customer</h1>} />
                        <Route path="/verified-customers" element={<h1 className="title">Verified Customers</h1>} />
                        <Route path="/new-product" element={<h1 className="title">New Product</h1>} />
                        <Route path="/inventory" element={<h1 className="title">Inventory</h1>} />
                        {/* <Route path="/orders" element={<h1 className="title">Settings</h1>} /> */}
                    </Route>
                </Route>
            </Routes>
        </ThemeProvider>
    );
}

export default Admin;